<!-- app-details-dialog.component.html -->
<h1 mat-dialog-title class="header"><i class="fa fa-pencil"></i> Create App </h1>
<div class="mat-dialog-content1">
  <mat-form-field>
    <input matInput placeholder="App code"  id="cd" [(ngModel)]="data.cl_cd">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="App Name" id="value"  [(ngModel)]="data.cl_val">
  </mat-form-field>
  <mat-form-field>
    <textarea matInput placeholder="App Description" id="description" [(ngModel)]="data.cl_desc" rows="3"></textarea>
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button mat-button class="btn1" (click)="onSave()">Save</button>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
</div>
